import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { screen } from 'legacy/styles/screen'

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${getToken('space-l')};

  ${screen.md} {
    flex-wrap: unset;
    justify-content: flex-start;
  }
`

export const ImageWrapper = styled.div`
  min-width: 200px;
  flex-basis: 230px;
  flex-grow: 0;
`

export const ContentWrapper = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
`
